import React from "react"
import { Link } from "gatsby"

const MoreEvents = () => (
    <div className="container-fluid color-three mt-3">
        <div className="row align-items-center p-4">
            <div className="col">
                <Link to="/events" className="text-decoration-none">
                    <p className="med-text-color-bg text-center m-0">See more events.</p>
                </Link>
            </div>
        </div>
    </div>
)

export default MoreEvents